import React from 'react';
import MarketerNavbar from './MarketerNavbar';
import MarketerHero from './MarketerHero';
import MarketerPainPoints from './MarketerPainPoints';
import MarketerFeatures from './MarketerFeatures';
import MarketerPricing from './MarketerPricing';
import MarketerSocialProof from './MarketerSocialProof';
import MarketerUseCases from './MarketerUseCases';
import MarketerFAQ from './MarketerFAQ';
import MarketerFooter from './MarketerFooter';

const MarketerPage: React.FC = () => {
  return (
    <div className="bg-slate-950 min-h-screen text-slate-300 font-sans antialiased selection:bg-sky-500/30 selection:text-sky-200">
      <MarketerNavbar />
      <main>
        <MarketerHero />
        <MarketerPainPoints />
        <MarketerFeatures />
        <MarketerUseCases />
        <MarketerSocialProof />
        <MarketerPricing />
        <MarketerFAQ />
      </main>
      <MarketerFooter />
    </div>
  );
};

export default MarketerPage;